module.exports = __webpack_public_path__ + "media/V49.84b17a10.mp4";